import { render, staticRenderFns } from "./ChatVersionSelection.vue?vue&type=template&id=2065c082"
import script from "./ChatVersionSelection.vue?vue&type=script&lang=js"
export * from "./ChatVersionSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports